export default "__VITE_ASSET__CC8P4V7J__"